import {
  ADD_ACCOUNTS,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNTS,
} from "../../constants/reduxConstants";

export const addAccountsAction = (payload) => {
  return {
    type: ADD_ACCOUNTS,
    payload,
  };
};

export const removeAllAccountsAction = (payload) => {
  return {
    type: REMOVE_ACCOUNTS,
    payload,
  };
};

export const deleteOneAccountAction = (payload) => {
  return {
    type: REMOVE_ACCOUNT,
    payload,
  };
};
